module.exports = new __parcel__URL__("photostudionight.91219876.hdr").toString();